import React from 'react';

import { Money, formatMoney } from '@betterment/js-runtime';
import { Text } from '@betterment/samba-react';

type Props = {
  amount: Money;
};
export const GainsLosses: React.FC<Props> = ({ amount }) => {
  const gain = (
    <Text variant="text50" color="text.success" css={{ marginTop: 'space.25' }}>
      +{formatMoney(amount)}
    </Text>
  );

  const loss = (
    <Text variant="text50" color="text.weak">
      {formatMoney(amount)}
    </Text>
  );

  return amount.cents > 0 ? gain : loss;
};
